import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

type ElementType = HTMLElement | null | undefined;
@Directive({
    selector: '[cwChromePickerSelector]',
    standalone: false,
})
export class ChromePickerStylesDirective implements OnInit {
    private popupPicker: HTMLElement | null = null;

    private _colorBackground = '';

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        this.popupPicker = this.el.nativeElement;
        this.modifyHeaderStyle(this.colorBackground);
        this.modifyContentStyle();
        this.removeUnnecessaryPickerStyles();
    }

    modifyHeaderStyle(value: string): void {
        const header: ElementType = this.popupPicker?.querySelector('div.twc-popup-header');
        const caption: ElementType = this.popupPicker?.querySelector('.twc-popup-header .twc-popup-header-caption');
        if (header) {
            this.renderer.setStyle(header, 'background-color', value);
            this.renderer.setStyle(header, 'justify-content', 'center');
            this.renderer.setStyle(header, 'padding', '30px');
        }
        if (caption) {
            this.renderer.setStyle(caption, 'color', this.pickTextColorBasedOnBgColor(value, '#FFFFFF', '#000000'));
        }
    }

    modifyContentStyle(): void {
        const content: ElementType = this.popupPicker?.querySelector('twc-popup-content');
        this.renderer.setStyle(content, 'padding', '8px');
    }

    removeUnnecessaryPickerStyles(): void {
        const picker: ElementType = this.popupPicker?.querySelector('sketch-picker');
        this.renderer.setStyle(picker, 'width', '100%');
        this.renderer.setStyle(picker, 'box-shadow', 'none');
    }

    @Input()
    set colorBackground(value: string) {
        this._colorBackground = value;
        this.modifyHeaderStyle(value);
    }

    get colorBackground(): string {
        return this._colorBackground;
    }

    pickTextColorBasedOnBgColor(bgColor: string, lightColor: string, darkColor: string): string {
        const color = bgColor.startsWith('#') ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16);
        const g = parseInt(color.substring(2, 4), 16);
        const b = parseInt(color.substring(4, 6), 16);
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
    }
}
